import { useMemo, useState } from "react";
import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";

const cmp = (a, b) => {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return typeof a === "string" || typeof b === "string" ? String(a).localeCompare(String(b), undefined, { numeric: true }) : a - b;
};

export const useSort = (rows, accessors, initial = { key: null, dir: "desc" }) => {
  const [sort, setSort] = useState(initial);
  const sorted = useMemo(() => {
    const get = accessors[sort.key];
    if (!get) return rows;
    const out = [...rows].sort((a, b) => cmp(get(a), get(b)));
    return sort.dir === "desc" ? out.reverse() : out;
  }, [rows, sort, accessors]);
  const toggle = (key) => setSort((s) => (s.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" }));
  return { sorted, sort, toggle };
};

export const SortTh = ({ k, label, sort, toggle, className = "py-1.5 pr-3" }) => {
  const active = sort.key === k;
  const Icon = !active ? ArrowUpDown : sort.dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <th className={`${className} font-normal uppercase tracking-wider`}>
      <button type="button" onClick={() => toggle(k)} data-testid={`sort-${k}`}
        className={`inline-flex items-center gap-1 uppercase tracking-wider hover:text-white transition-colors ${active ? "text-white" : ""}`}>
        {label}<Icon className={`w-3 h-3 ${active ? "text-[#3B9BFF]" : "opacity-40"}`} />
      </button>
    </th>
  );
};
